import { memberApiV2 } from '@lib/api';
import { IClientSearchParams, IClientSearchRes, TClientPairingStatus } from 'types/client.types';
import { TPaginatedResult } from 'types/pagination.types';
import { TWaiting } from 'types/patients';

export function inviteClient(providerId: string, data: { phoneNumber: string; message: string }) {
  return memberApiV2.request('/management/private/client/invite', {
    method: 'POST',
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function searchClients(providerId: string, params: IClientSearchParams) {
  return memberApiV2.request<{ data: IClientSearchRes }>('/management/private/client/search', {
    method: 'POST',
    data: params,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function responseToPairing(
  providerId: string,
  clientId: string,
  status: TClientPairingStatus,
) {
  return memberApiV2.request(`/management/private/client/pairing/${clientId}`, {
    method: 'POST',
    data: {
      status,
    },
    headers: {
      'provider-id': providerId,
    },
  });
}

export function addToMyClients(providerId: string, clientId: string) {
  return memberApiV2.request('/management/private/client/add', {
    method: 'POST',
    data: { clientId },
    headers: { 'provider-id': providerId },
  });
}

export function removeFromMyClients(providerId: string, clientId: string) {
  return memberApiV2.request('/management/private/client/remove', {
    method: 'DELETE',
    data: { clientId },
    headers: { 'provider-id': providerId },
  });
}

export function getMyClientRequest(providerId: string) {
  return memberApiV2.request<{ data: TPaginatedResult<TWaiting> }>(
    '/management/private/client/get-my-client-requests',
    {
      method: 'POST',
      headers: { 'provider-id': providerId },
    },
  );
}

export function searchClientsPublic(providerId: string, params: IClientSearchParams) {
  return memberApiV2.request<{ data: IClientSearchRes }>('/management/private/client/search', {
    method: 'POST',
    data: params,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function getClientDetail(providerId: string, clientId: string) {
  // FIXME: remove types
  return memberApiV2.request<{
    data: {
      id: string;
      jabberId: string;
      profile: {
        firstName: string;
        lastName: string;
        titleBeforeName: null;
        titleAfterName: null;
        profileImage: null;
        pin: string;
      };
    };
  }>('/management/private/client/detail', {
    method: 'GET',
    params: { clientId },
    headers: { 'provider-id': providerId },
  });
}
